import React from 'react';
const Pause = ({ fill = 'currentColor', width = 20, height = 20 }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="3" width="4" height="14" rx="1" fill={fill} />
    <rect x="12" y="3" width="4" height="14" rx="1" fill={fill} />
  </svg>
);
export default Pause;
